import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_EVENT_REQUEST,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAILURE,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  GET_EVENT_REQUEST,
  GET_EVENT_SUCCESS,
  GET_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
} from "../constants/eventConstant";

export const addEventAction = (eventData) => async (dispatch) => {
  for (var pair of eventData.entries()) {
    console.log("eventData:", pair[0] + ":" + pair[1]);
  }
  try {
    dispatch({ type: ADD_EVENT_REQUEST });
    const url = ApiUrl.createEvent;
    const { data } = await axios.post(url, eventData);

    if (data.success) {
      dispatch({
        type: ADD_EVENT_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_EVENT_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_EVENT_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const updateEventAction = (eventId, eventData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EVENT_REQUEST });
    // for (var pair of eventData.entries()) {
    //   console.log(pair[0] + ":" + pair[1]);
    // }
    let config = {
      headers: { 'Content-type': 'application/json' },
    };
    const URL = `${ApiUrl.updateEvent}?eventId=${eventId}`;
    const { data } = await axios.put(URL, eventData, config);
    if (data.success) {
      dispatch({
        type: UPDATE_EVENT_SUCCESS,
        payload: true,
      });
      return true;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: UPDATE_EVENT_FAILURE,
        payload: error.response.data,
      });
    } else {
      dispatch({
        type: UPDATE_EVENT_FAILURE,
        payload: "Internal Server Error",
      });
    }
  }
};

export const getEventAction = (eventId) => async (dispatch) => {
  try {
    dispatch({ type: GET_EVENT_REQUEST });
    const URL = `${ApiUrl.getEventById}?eventId=${eventId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_EVENT_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_EVENT_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_EVENT_FAILURE,
        payload: error.response.data,
      });
    }
  }
};

export const deleteEventAction = (_id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EVENT_REQUEST });
    const URL = `${ApiUrl.deleteEvent}?eventId=${_id}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_EVENT_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_EVENT_FAILURE,
      payload: error.response.data,
    });
  }
};
